import ptBR from "antd/lib/date-picker/locale/pt_BR";
import moment from "moment";
import "moment/locale/pt-br";

export const API_DATE_FORMAT = "YYYY-MM-DD";

/** Atalhos de período usados em todos os calendários do sistema. */
export const praxRanges = (): any => ({
  Hoje: [moment().startOf("day"), moment().endOf("day")],
  Ontem: [
    moment().subtract(1, "day").startOf("day"),
    moment().subtract(1, "day").endOf("day"),
  ],
  "7 dias": [moment().subtract(6, "days").startOf("day"), moment().endOf("day")],
  "15 dias": [moment().subtract(14, "days").startOf("day"), moment().endOf("day")],
  "30 dias": [moment().subtract(29, "days").startOf("day"), moment().endOf("day")],
  "Mês atual": [moment().startOf("month"), moment().endOf("month")],
  "Mês passado": [
    moment().subtract(1, "month").startOf("month"),
    moment().subtract(1, "month").endOf("month"),
  ],
});

/** Período padrão do sistema: mês atual. */
export const praxDefaultRange = (): any => [
  moment().startOf("month"),
  moment().endOf("day"),
];

/** Props padrão (leitura em pt-BR, DD/MM/YYYY, sem datas futuras). */
export const praxPickerProps = (): any => ({
  defaultValue: praxDefaultRange(),
  locale: ptBR,
  ranges: praxRanges(),
  format: "DD/MM/YYYY",
  separator: "→",
  allowClear: true,
  inputReadOnly: true,
  className: "px-picker",
  dropdownClassName: "px-picker-dropdown",
  placeholder: ["Data Inicial", "Data Final"],
  disabledDate: (current: any) => !!current && current > moment().endOf("day"),
});

/** Converte a seleção do RangePicker para o formato aceito pela API. */
export const praxRangeToApi = (dates: any): [string | null, string | null] => {
  if (!dates || !dates[0] || !dates[1]) return [null, null];
  return [dates[0].format(API_DATE_FORMAT), dates[1].format(API_DATE_FORMAT)];
};
